import {EventSourcePolyfill} from "event-source-polyfill";
const baseURL = process.env.VUE_APP_API_ENDPOINT

export function createStream(url) {
    try {
        return new EventSourcePolyfill(baseURL + url, {
            headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
            }
        });
    } catch (error) {
        console.error("Error creating EventSource:", error);
    }
}

